import { useAxiosRequest } from "api/axiosRequest"
import { BASE_URL } from "api/url_helper"
import { isAxiosError } from "axios"
import { useState } from "react"
import { toast } from "react-toastify"


export function useDeleteVesselFromList() {
  const [isDeleteVesselLoading, setIsDeleteVesselLoading] =
    useState<boolean>(false)
  const request = useAxiosRequest()
  const deleteVesselFromList = async (vesselInfoID: string, source?: string) => {
    setIsDeleteVesselLoading(true)
    try {
      await request<any, any>({
        url: `${BASE_URL}/vesseltracking/vessel/single`,
        method: "DELETE",
        params: { vesselInfoID, ...(source ? { source } : {}) },
      })
    } catch (err: unknown) {
      const message = "failed to delete vessel from list"
      console.error(message, err)
      if (isAxiosError(err)) {
        toast.warn(message, {
          position: "bottom-right",
          autoClose: 8000,
        })
      }
      throw err
    } finally {
      setIsDeleteVesselLoading(false)
    }
  }
  return { deleteVesselFromList, isDeleteVesselLoading }
}
